<template>
  <v-flex>
    <div id="vueapp" class="vue-app">
      <v-btn v-if="totalRows" @click="exportExcel(false)">Export Excel</v-btn>
      <v-btn v-if="totalRows" @click="exportExcel(true)"
        >Export All Pages Excel</v-btn
      >

      <loadingcomp :showLoading="showLoading" />
      <Grid
        ref="grid"
        :style="{ height: '520px' }"
        :data-items="kendoItems"
        :take="take"
        :skip="skip"
        :resizable="true"
        :groupable="true"
        :reorderable="true"
        :sortable="true"
        :filterable="true"
        :filter="kendoFilterGrid"
        :group="group"
        :sort="kendoSort"
        :expand-field="'expanded'"
        :pageable="gridPageable"
        :total="totalRows"
        :columns="kendoHeaders"
        @expandchange="expandChange"
        @datastatechange="dataStateChange"
        @pagechange="pageChangeHandler"
        @sortchange="sortChangeHandler"
        @filterchange="filterChange"
      ></Grid>
    </div>
  </v-flex>
</template>
<script>

import loadingcomp from "../../Components/loadingComponent.vue";
import { required } from "vuelidate/lib/validators";
import { Grid } from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import Vue from "vue";
import customStringComponent from "./customStringKendoGridComponent.vue";
import customDateKendoGridComponent from "./customDateKendoGridComponent.vue";
import customNumericKendoGridComponent from "./customNumericKendoGridComponent.vue";
import customBooleanKendoGridComponent from "./customBooleanKendoGridComponent.vue";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import extractionApi from "../../apiSmartLogistics/extractionApi.js";
var workbook_1 = require("@progress/kendo-vue-excel-export/dist/npm/ooxml/workbook");
var kendo_file_saver_1 = require("@progress/kendo-file-saver");

Vue.component("customStringComponent", customStringComponent);
Vue.component("customDateKendoGridComponent", customDateKendoGridComponent);
Vue.component("customBooleanGridComponent", customBooleanKendoGridComponent);
Vue.component("customNumericComponent", customNumericKendoGridComponent);

export default {
  components: {
    Grid,
    loadingcomp
  },
  validations: {
    column: { required },
    value: { required },
    filter: { required }
  },
  props: {
    // titolo in alto a sinistra nell'header della griglia
    title: String,
    // testo del bottone di aggiunta elemento
    newLabel: String,
    // visualizzazione del bottone crea elemento
    CanCreate: Boolean,
    // nome del controller della webapi per fare le chiamate crud base
    controller: String,
    create: String,
    delete: String,
    edit: String,
    readAll: String,
    // lista delle colonne della griglia con i relativi settaggi {text:'Storage' value: 'Storage', sortable: false, width: '5', filterable: false, type: Boolean }
    // sono richiesti: value (nome colonna sul db) e type (solo se il tipo di dato è diverso da stringa)
    // filtri per colonne che non sono visualizzate nel front end ma che sulla tabella del db esistono
    customFilters: Array,
    // disabilito pulsante Edit menu contestuale
    disableEdit: Boolean,
    // disabilito pulsante Delete menu contestuale
    disableDelete: Boolean,
    // nomi colonne da nascondere
    hideColumns: Array,
    // refresh griglia
    refresh: Boolean,
    payload: Object
  },
  data() {
    return {
      showLoading: false,
      headers: [],
      kendoHeaders: [{ field: "Id", title: "" }],
      snackbar: { Timeout: 10000, Visible: false },
      dialogDelete: false,
      dialogFilter: false,
      CurObj: "",
      items: [],
      kendoItems: [],
      kendoSort: [],
      gridPageable: { pageSizes: ["20", "50", "100", "1000"] },
      skip: 0,
      take: 10,
      group: [],
      totalRows: 0,
      filters: [],
      loading: true,
      column: "",
      filter: "",
      value: "",
      valueBoolean: false,
      isBoolean: false,
      currentFilter: "",
      pagination: {},
      headersFilter: [],
      headersKendoFilter: [],
      kendoFilter: [],
      kendoFilterGrid: {},
      currentTypeFilters: "",
      currentTypeFiltersList: [],
      errorAlert: false,
      errorMessage: ""
    };
  },
  beforeMount: function() {
    //this.CalculateHeadersFilter();
  },
  watch: {
    pagination: {
      handler() {},
      deep: true
    },
    filters: {
      handler() {},
      deep: true
    },
    refresh: {
      handler() {
        this.reloadKendoGrid();
      }
    }
  },
  methods: {
    //
    // DELETE
    // mostra il popup di conferma eliminazione elemento
    Delete: function(obj) {
      this.dialogDelete = true;
      this.CurObj = null;
      this.CurObj = obj;
    },
    // dopo la conferma dell'eliminazione chiama la webapi per fare la delete vera e propria
    DeleteConfirmed: function() {
      this.$http
        .get(this.controller + this.Delete + "?RepoCode=" + this.CurObj)
        .then(result => {
          this.snackbar.Color = "success";
          this.snackbar.Visible = true;
          this.snackbar.Message = result.data;
          this.reload();
        })
        .catch(result => {
          this.snackbar.Color = "error";
          this.snackbar.Visible = true;
          this.snackbar.Message = result.response.data;
        });
    },
    //
    // EDIT
    //
    Edit: function(obj) {
      this.$router.push(this.edit + "/" + obj);
    },
    //
    // READ
    //
    getDataFromApi() {
      this.loading = true;
      let { sortBy, descending, page, rowsPerPage } = this.pagination;
      if (!descending) {
        descending = false;
      }

      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: rowsPerPage,
        filters: this.filters,
        payload: this.payload
      };
      
      return this.$http.post(this.controller + this.readAll + "/", filters);
    },
    getKendoDataFromApi(resetPagination) {
      var descending = false;
      var sortBy = []
      var filtersApi = [];
      if (this.kendoSort && this.kendoSort[0]) {
        descending = this.kendoSort[0].dir == "desc" ? true : false;
        sortBy = [this.kendoSort[0].field];
      }

      filtersApi = this.getFilters(resetPagination);

      var page = this.skip / this.take + 1;

      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: this.take,
        filters: filtersApi,
        payload: this.payload
      };

      this.loadSpinner();
      
      return this.$http.post(this.controller + this.readAll + "/", filters);
    },
    getFilters(resetPagination) {
      var filtersApi = [];
      var headersTemp = this.kendoHeaders;

      if (
        this.kendoFilter &&
        this.kendoFilter.filters &&
        this.kendoFilter.filters.length > 0
      ) {
        if (resetPagination) {
          this.skip = 0;
        }
        var headerType = "";
        this.kendoFilter.filters.forEach(el => {
          headersTemp.find(h => {
            if (h.field == el.field && h.filter) {
              headerType = h.filter;
            } else {
              headerType = "";
            }
          });
          var filtersApiTemp = {
            filterType: this.mapFilterOperatorKendoToFercamCustom(
              el.operator,
              headerType
            ),
            field: el.field,
            filtervalue: el.value
          };
          filtersApi.push(filtersApiTemp);
        });
      }
      return filtersApi;
    },
    loadSpinner() {
      if (!document.getElementById("spinner")) {
        var loadingIcon = document.createElement("span");
        loadingIcon.className = "k-icon k-i-loading";
        loadingIcon.style.color = "#3f51b5";
        loadingIcon.id = "spinner";
        var vueapp = document.getElementById("vueapp");
        vueapp.appendChild(loadingIcon);
        //vueapp.setAttribute("v-cloak", null);
      } else {
        document.getElementById("spinner").style.display = "block";
      }
    },
    reload() {
      this.getDataFromApi()
        .then(data => {
          this.loading = false;
          this.items = data.data.items;

          this.totalRows = data.data.totalRows;
          this.headers = [];
          this.errorAlert = false;
          if (data.data.items[0]) {
            Object.getOwnPropertyNames(data.data.items[0]).forEach(element => {
              if (element !== "__ob__" && element !== "RowNum") {
                var header = { value: element, text: element };

                this.headers.push(header);
              }
            });
          }

          this.CalculateHeadersFilter();
        })
        .catch(() => {
          this.loading = false;
          this.errorAlert = true;
          this.errorMessage = "Errore";
        });
    },
    reloadKendoGrid(resetPagination = true) {
      
      var descending = false;
      var sortBy = [];
      var filtersApi = [];
      if (this.kendoSort && this.kendoSort[0]) {
        descending = this.kendoSort[0].dir == "desc" ? true : false;
        sortBy = [this.kendoSort[0].field];
      }

      filtersApi = this.getFilters(resetPagination);

      var page = this.skip / this.take + 1;

      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: this.take,
        filters: filtersApi,
        payload: this.payload
      };

      this.loadSpinner();

      extractionApi.ExecuteQuery(filters).then(data => {
          if (document.getElementById("spinner")) {
            document.getElementById("spinner").style.display = "none";
          }
          this.loading = false;

          var x = process(data.data.items, {
            group: this.group
          });
          this.kendoItems = x;
          this.totalRows = data.data.totalRows;
          var kendoHeadersTemp = this.kendoHeaders;
          this.errorAlert = false;

          if (kendoHeadersTemp.length == 1 && data.data.items[0]) {
            this.kendoHeaders = [];
            var dataItemsTemp = data.data.items[0];
            for (var propertyName in dataItemsTemp) {
              if (propertyName !== "__ob__" && propertyName !== "RowNum") {
                var pname = (propertyName.includes("__") && propertyName.split("__")[0]) ? propertyName.split("__")[0] : propertyName;
                var kendoHeader = {
                  field: propertyName,
                  title: pname.includes("_") ? pname.replaceAll("_", " ") : pname
                };
                var length =
                  this.longestContent(data.data.items, propertyName) * 10;
                if (!isNaN(length)) {
                  kendoHeader.width = length < 300 ? "300" : length.toString();
                } else {
                  kendoHeader.width = "300";
                }
                var fieldTypeName = this.getFieldType(propertyName);
                if (fieldTypeName == "date") {
                  kendoHeader["filter"] = fieldTypeName;
                  kendoHeader["format"] = "{0:d}";
                  kendoHeader["filterCell"] = "customDateKendoGridComponent";
                } else if (fieldTypeName == "numeric") {
                  kendoHeader["filter"] = fieldTypeName;
                  var b = 0;
                  data.data.items.forEach(element => {
                    b = +element[propertyName] + +b;
                  });
                  kendoHeader["filterCell"] = "customNumericComponent";
                } else if (fieldTypeName == "boolean") {
                  kendoHeader["filter"] = fieldTypeName;
                  var a = 0;
                  data.data.items.forEach(element => {
                    a = +element[propertyName] + +a;
                  });
                  kendoHeader["filterCell"] = "customBooleanGridComponent";
                } else {
                  kendoHeader["filterCell"] = "customStringComponent";
                }
                this.kendoHeaders.push(kendoHeader);
              }
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorAlert = true;
          this.errorMessage = "Errore";
          if (document.getElementById("spinner")) {
            document.getElementById("spinner").style.display = "none";
          }
        });
    },
    exportExcel(all) {
      if (all) {
        this.showLoading = true;
        this.take = 99999;
        this.exportAllToExcel();
        this.take = 10;
      }

      if(!all){
        saveExcel({
          data: this.kendoItems.data,
          fileName: "SmartLogistics_Export",
          columns: this.kendoHeaders
        });
      }     
    },
    async exportAllToExcel(){
      var descending = false;
      var sortBy = [];
      var filtersApi = [];
      if (this.kendoSort && this.kendoSort[0]) {
        descending = this.kendoSort[0].dir == "desc" ? true : false;
        sortBy = [this.kendoSort[0].field]
      }

      filtersApi = this.getFilters(false);

      var page = this.skip / this.take + 1;

      let filters = {
        sortBy: sortBy,
        descending: descending,
        page: page,
        rowsPerPage: this.take,
        filters: filtersApi,
        payload: this.payload
      };

      var dataNew = await extractionApi.ExecuteQuery(filters);      
        await this.saveExcelNew({
          data: dataNew.data.items,
          fileName: "SmartLogistics_Export",
          columns: this.kendoHeaders
        });
        this.showLoading = false;
    },

    async saveExcelNew(exportOptions) {
        var saveFn = function (dataURL) {
            kendo_file_saver_1.saveAs(dataURL, exportOptions.fileName, {
                forceProxy: exportOptions.forceProxy,
                proxyURL: exportOptions.proxyURL
            });
        };
        var options = workbook_1.workbookOptions(exportOptions);
        await workbook_1.toDataURL(options).then(saveFn);
    },

    expandChange(event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
      //this.$emit("expandchange");
    },
    dataStateChange(event) {
      this.createAppState(event.data);
    },
    createAppState: function(dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.reloadKendoGrid();
    },
    pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      this.reloadKendoGrid(false);
    },
    sortChangeHandler: function(e) {
      this.kendoSort = e.sort;
      this.reloadKendoGrid();
    },
    filterChange: function(ev) {
      var evChangeFilterType = "";
      if (ev.event) {
        if (ev.event.syntheticEvent) {
          evChangeFilterType = ev.event.syntheticEvent.type;
        }
      }
      this.kendoFilter = ev.filter;
      this.kendoFilterGrid = ev.filter;

      if (evChangeFilterType == "keyup" || ev.event.operator == "Reset") {
        this.reloadKendoGrid();
      }
    },
    getFieldType(field) {
      if (
        field.includes("__") &&
        field.split("__")[1] &&
        field.split("__")[1].trim().length > 0
      ) {
        var filterTypes = ["string", "boolean", "date", "numeric"];
        if (filterTypes.includes(field.split("__")[1].trim())) {
          return field.split("__")[1];
        }
      }
      return "string";
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    },
    mapFilterOperatorKendoToFercamCustom(operator, type) {
      var fercamOperator = "";

      operator = operator + type;

      switch (operator) {
        case "eq":
          fercamOperator = "Equal";
          break;
        case "startswith":
          fercamOperator = "StartWith";
          break;
        case "contains":
          fercamOperator = "Contains";
          break;
        case "gt":
          fercamOperator = "Bigger";
          break;
        case "lt":
          fercamOperator = "Smaller";
          break;
        case "gtdate":
          fercamOperator = "From";
          break;
        case "ltdate":
          fercamOperator = "To";
          break;
        default:
          break;
      }

      return fercamOperator;
    },
    changeFilterbtnClass(btnFilter, visible) {
      visible
        ? btnFilter.classList.add("k-clear-button-visible")
        : btnFilter.classList.remove("k-clear-button-visible");
    },
    //
    // FILTERS
    //
    // Calcola i campi disponibili per essere filtrati
    CalculateHeadersFilter() {
      this.headersFilter = this.headers.slice();
      if (this.customFilters) {
        this.customFilters.forEach(cf => {
          this.headersFilter.push(cf);
        });
      }
      this.headersFilter.forEach(hf => {
        if (hf.filterable === false) {
          this.headersFilter.splice(this.headersFilter.indexOf(hf), 1);
        }
      });
      this.filters.forEach(filtr => {
        var index = -1;
        this.headersFilter.forEach(hf => {
          if (hf.filterable === false) {
            index = this.headersFilter.indexOf(hf);
          }
          if (hf.value === filtr.field) {
            index = this.headersFilter.indexOf(hf);
          }
        });
        this.headersFilter.splice(index, 1);
      });
    },
    /// rimuove il filtro dalla lista dei filtri disponibili per evitare di filtrare piu volte lo stesso campo
    remove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.filters = [...this.filters];
      this.CalculateHeadersFilter();
    },
    addFilter: function() {
      if (!this.isBoolean) {
        // this.$v.$touch();
        // if (this.$v.$error) return;
      }
      var filter = {
        filterType: this.isBoolean ? "Equal" : this.filter,
        field: this.column,
        filtervalue: this.isBoolean ? this.valueBoolean : this.value
      };
      this.filters.push(filter);
      this.dialogFilter = false;
      this.filter = null;
      this.column = null;
      this.value = null;
      this.isBoolean = false;
      this.CalculateHeadersFilter();
    },
    // quando si cambia il campo da filtrare prepara il resto della form al tipo di dato del campo
    filterFieldSelected: function(field) {
      this.isBoolean = false;
      this.headersFilter.forEach(hf => {
        if (hf.value === field) {
          switch (hf.type) {
            case Date:
              this.currentTypeFilters = "Date";
              this.currentTypeFiltersList = ["From", "To", "Equal"];
              break;
            case Number:
              this.currentTypeFilters = "Number";
              this.currentTypeFiltersList = ["Bigger", "Smaller", "Equal"];
              break;
            case Boolean:
              this.isBoolean = true;
              this.filter = "Equal";
              this.currentFilter = hf.text;
              this.currentTypeFilters = "Boolean";
              this.currentTypeFiltersList = ["Equal"];
              break;
            default:
              this.currentTypeFilters = "Text";
              this.currentTypeFiltersList = ["StartWith", "Contains"];
              break;
          }
        }
      });
    },
    //
    isHiddenColumn(key) {
      let classColumn = "text-xs-left ";
      if (this.hideColumns) {
        this.hideColumns.forEach(col => {
          if (col === key) {
            classColumn += "hide-column text-xs-left";
          }
        });
      }
      if (key === "RowNum") {
        classColumn += "hide-column text-xs-left";
      }
      return classColumn;
    },
    longestContent(kendoItems, propertyName) {
      try {
        var a = kendoItems.slice(0).sort(function(a, b) {
          var dsf =
            b[propertyName].toString().length -
            a[propertyName].toString().length;

          return dsf;
        })[0][propertyName].length;

        return a;
      } catch (error) {
        return 1;
      }
    }
  },
  computed: {
    // validazione campo filter
    filterErrors() {
      const errors = [];
      //if (!this.$v.filter.$dirty) return errors;
      //  !this.$v.filter.required && errors.push(requiredMsg);
      return errors;
    },
    // validazione campo column
    columnErrors() {
      const errors = [];
      //if (!this.$v.column.$dirty) return errors;
      //  !this.$v.column.required && errors.push(requiredMsg);
      return errors;
    },
    // validazione campo value
    valueErrors() {
      const errors = [];
      // if (!this.$v.value.$dirty) return errors;
      // !this.$v.value.required && errors.push(requiredMsg);
      return errors;
    }
  }
};
</script>
<style>
.v-table__overflow {
  overflow-y: auto !important;
}
.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}
table {
  table-layout: fixed;
}
th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}
th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
tr.v-datatable__progress th {
  height: 1px;
}
.v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}
.v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}
.v-datatable__actions {
  flex-wrap: nowrap;
}
.v-datatable__actions__pagination {
  white-space: nowrap;
}
.hide-column {
  display: none;
}
#vueapp {
  display: block;
  width: 100%;
  overflow: hidden;
  min-height: 80px;
  box-sizing: border-box;
  padding: 30px;
}
.example-wrapper {
  min-height: 280px;
  align-content: flex-start;
}
.example-wrapper p,
.example-col p {
  margin: 0 0 10px;
}
.example-wrapper p:first-child,
.example-col p:first-child {
  margin-top: 0;
}
.example-col {
  display: inline-block;
  vertical-align: top;
  padding-right: 20px;
  padding-bottom: 20px;
}
.example-config {
  margin: 0 0 20px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.event-log {
  margin: 0;
  padding: 0;
  max-height: 100px;
  overflow-y: auto;
  list-style-type: none;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-color: #fff;
}
.event-log li {
  margin: 0;
  padding: 0.3em;
  line-height: 1.2em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.event-log li:last-child {
  margin-bottom: -1px;
}
.k-i-loading {
  font-size: 64px !important;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
